<bwh-lib-step-control-bar
  [closeBut]="true"
  [withProgress]="false"
  (emitClose)="emitClose.emit()"
></bwh-lib-step-control-bar>
<div class="text-center">
  <div class="main-header">
    <h1 class="main-title">{{ 'global.confirm_delete_account' | translate }}</h1>
  </div>
  <p class="warning">{{ 'global.delete_account_warning' | translate }}</p>
  <div class="form-container">
    <form [formGroup]="form" (submit)="deleteAccount()">
      <div class="form-field-container">
        <div class="form-field-label">
          {{ 'form.field.password' | translate }}
        </div>
        <mat-form-field class="form-field form-field-password" [floatLabel]="'never'">
          <input
            matInput
            [type]="hidePwd ? 'password' : 'text'"
            formControlName="password"
            required
          />
          <mat-error *ngIf="getFormControl('password').invalid">
            <ng-container *ngIf="getFormControl('password').errors.required">
              {{ 'form.error.required' | translate }}
            </ng-container>
            <ng-container *ngIf="getFormControl('password').errors.incorrect_password">
              {{ 'form.error.incorrect_password' | translate }}
            </ng-container>
          </mat-error>
        </mat-form-field>
        <span
          class="form-field-icon"
          [ngClass]="{ active: !hidePwd }"
          [inlineSVG]="'/icons/icon-eye.svg'"
          (click)="hidePwd = !hidePwd; $event.preventDefault()"
        ></span>
      </div>

      <div class="btn-container">
        <button type="submit" class="btn btn-red" [disabled]="form.invalid || loading">
          <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
          <span *ngIf="!loading">{{ 'global.delete_account' | translate }}</span>
        </button>
        <button type="button" class="btn btn-secondary" (click)="emitClose.emit()">
          {{ 'global.cancel' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
